module.exports = __webpack_public_path__ + "img/icon_sm_qxcb.d55c0c04.png";